// REISOR_PHONE_VERIFY_RETURN_SIGNAL_V1
export const PHONE_VERIFICATION_RETURN_SIGNAL_KEY = "reisor_phone_verification_return_v1";
export const PHONE_VERIFICATION_RETURN_SIGNAL_TTL_MS = 10 * 60 * 1000;

function stores() {
  const out = [];
  try { if (window?.localStorage) out.push(window.localStorage); } catch {}
  try { if (window?.sessionStorage) out.push(window.sessionStorage); } catch {}
  return out;
}

export function markPhoneVerificationReturnSignal(now = Date.now()) {
  const at = Number(now);
  if (!Number.isFinite(at) || at <= 0) return false;
  const value = JSON.stringify({ status: "done", at });
  let ok = false;
  for (const s of stores()) {
    try { s.setItem(PHONE_VERIFICATION_RETURN_SIGNAL_KEY, value); ok = true; } catch {}
  }
  return ok;
}

export function hasFreshPhoneVerificationReturnSignal(now = Date.now()) {
  const current = Number(now);
  if (!Number.isFinite(current) || current <= 0) return false;

  for (const s of stores()) {
    let raw = "";
    try { raw = String(s.getItem(PHONE_VERIFICATION_RETURN_SIGNAL_KEY) || ""); } catch {}
    if (!raw) continue;

    try {
      const v = JSON.parse(raw);
      const at = Number(v?.at);
      const age = current - at;

      if (
        String(v?.status || "").toLowerCase() === "done" &&
        Number.isFinite(at) &&
        at > 0 &&
        age >= -30000 &&
        age <= PHONE_VERIFICATION_RETURN_SIGNAL_TTL_MS
      ) return true;
    } catch {}

    try { s.removeItem(PHONE_VERIFICATION_RETURN_SIGNAL_KEY); } catch {}
  }

  return false;
}

export function clearPhoneVerificationReturnSignal() {
  for (const s of stores()) {
    try { s.removeItem(PHONE_VERIFICATION_RETURN_SIGNAL_KEY); } catch {}
  }
}
